<template>
    <div>
        <b-card class="fuente" order-variant="secondary"  header-text-variant="black">
            <div slot="header" align="center">
                <b-row>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="4">
                        <b-form inline>
                            <div>
                                Desde: <b-input type="date" v-model="f1" :placeholder="currentdate"/>
                            </div>
                            <div class="ml-4">
                                Hasta: <b-input type="date" v-model="f2" :placeholder="currentdate"/>
                            </div>  
                            <div class="ml-4">
                               <b-button @click="filtroHora()" style="border:none" title="mostrar filtro por Hora" variant="outline-dark"><i class="fas fa-clock"></i></b-button>
                            </div>
                        </b-form>
                        <!-- <b-form inline>
                            Desde: 
                            <datepicker  v-model="f1" 
                                :format="customFormatter" 
                                :bootstrap-styling="true"
                                :placeholder="currentdate"
                                class="ml-1">
                            </datepicker> 
                            Hasta:
                            <datepicker v-model="f2" 
                             <datepicker v-model="f2" 
                            <datepicker v-model="f2" 
                             <datepicker v-model="f2" 
                            <datepicker v-model="f2" 
                                :format="customFormatter" 
                                :bootstrap-styling="true"
                                :placeholder="currentdate"    
                                class="ml-1">
                            </datepicker>           
                        </b-form>    
                                            -->
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="7">
                        <div class="text-left">
                            <b-button title="Buscar Documentos" variant="success" @click="validacionHoras()">Buscar</b-button>
                        </div>                      
                    </b-col>
                    <b-col>
                        <b-button @click="exportarCajaBanco()" title="Exportar Excel" variant="warning">Exportar</b-button>
                    </b-col>
                </b-row>
                <b-row class="mt-1" v-if="mostrarfiltro">
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="4">
                        <b-form inline>
                        <div>
                            Desde (hrs-min)<b-form-input v-model="hora1" type="text" maxlength="2" style="width:50px"></b-form-input> :
                            <b-form-input :disabled="!hora1" v-model="minuto1" type="text" maxlength="2" style="width:50px"></b-form-input>
                        </div>
                        <div class="ml-4">
                            Hasta (hrs-min)<b-form-input :disabled="!minuto1" v-model="hora2" type="text" maxlength="2" style="width:50px"></b-form-input> :
                            <b-form-input :disabled="!hora2" v-model="minuto2" @keyup.enter="validacionHoras()" type="text" maxlength="2" style="width:50px"></b-form-input>
                        </div>
                        </b-form>
                    </b-col>      
                </b-row>
            </div>
            <!-- cargando -->
            <template v-if="cargando">
                <b-row>
                    <b-col>
                        <div class="text-center">
                            <h1> Cargando <i class="fa fa-spin fa-spinner"></i>      </h1>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <!-- Total general -->
            <template v-else>
            <div v-if="arrayTipoDocumento != ''">
                <div class="totalesGeneral ml-2">
                    <h4>S/.{{(totalVentas.totalSoles).toFixed(2)}}</h4>
                </div>
                <div  class="totalesGeneral ml-5">
                    <h4>  TOTAL : </h4>
                </div>
            </div>
            <div  v-if="arrayTipoDocumento != ''">
                <div  class="totalesGeneral ml-2">
                        <h4>$ {{(totalVentas.totalDolares).toFixed(2)}}</h4>
                </div>
                <div class="totalesGeneral">
                        <h4> TOTAL :  </h4>
                </div>
            </div>
            <!-- Tabla -->
            <div class="mt-5" v-for="(item,index) in arrayTipoDocumento" :key="index">
                <div style="background-color:lightblue;"><h3>{{item[0].tipoPago}}</h3></div>
                <b-table 
                    :bordered="bordered" 
                    :fixed="fixed" 
                    responsive 
                    head-variant="light" 
                    hover 
                    :outlined="outlined"  
                    small 
                    :items="arrayTipoDocumento[index]" 
                    :fields="tiposdocumentos" >
                    <template slot="index" slot-scope="row">
                        {{ row.index +1 }}
                    </template>
                    <template slot="documento" slot-scope="row">
                        {{row.item.serie}} - {{row.item.numero}}
                    </template>
                    <template slot="usuario" slot-scope="row">
                        {{row.item.usuario.username}} 
                    </template>
                    <template slot="tipoPago" slot-scope="row">
                        <template v-if="row.item.monedero == 1">
                            <div>
                                Yape
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 2">
                            <div>
                                Plin
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 3">
                            <div>
                                A Crédito
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 4">
                            <div>
                                Tarjeta de Débito
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 5">
                            <div>
                                Efectivo ventas menores 
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 6">
                            <div>
                                Tarjeta de Crédito emitida en Perú
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 7">
                            <div>
                               Depósito en cuenta
                            </div>
                        </template>
                        <template v-if="row.item.monedero == 8">
                            <div>
                               Transferencia de Fondos
                            </div>
                        </template>
                        <template v-else-if="row.item.monedero == null">
                            <div>
                              {{row.item.tipoPago}}
                            </div>
                        </template>
                    </template>
                </b-table>
                <b-row>
                    <b-col>
                        <table class="tablaTotales">
                            <tr>
                                <th colspan="2">Total</th>  
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>S/.{{(totales[index].totalSoles).toFixed(2)}}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td> $ {{(totales[index].totalDolares).toFixed(2)}}</td>
                            </tr>
                        </table>
                        <template v-if="item[0].monedero == 1 || item[0].monedero == 2 || item[0].monedero == 8">
                        <table class="tablaTotales">
                            <tr>
                                <th style="background-color:purple;color:white" colspan="2">Yape</th>  
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>S/.{{(yape).toFixed(2)}}</td>
                            </tr>
                        </table>
                        <table class="tablaTotales">
                            <tr>
                                <th style="background-color:skyblue;color:white" colspan="2">Plin</th>  
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>S/.{{(plin).toFixed(2)}}</td>
                            </tr>
                        </table>
                        <table class="tablaTotales">
                            <tr>
                                <th colspan="2">Trans. Fondos</th>  
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>S/.{{(trans).toFixed(2)}}</td>
                            </tr>
                        </table>
                        </template>
                    </b-col>
                </b-row>            
            </div>
            </template>
        </b-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import download from 'downloadjs'
export default {
    name:"CajaBancos",
    components:{
        Datepicker
    },
    data() {
        return {
            outlined:true,
            f1:'',
            f2:'',
            currentdate:'',
            totales:[],
            arrayTipoDocumento:[],
            tiposdocumentos:[
                {key:"index",label:"Nº"},
                {key:"documento",label:"Documento"},
                {key:"fechaRegistro",label:"Fecha registro"},
                {key:"idReceptor",label:"Receptor"},
                {key:"usuario",label:"Usuario"},
                {key:"tipoPago",label:"Forma de Pago"},
                {key:"tipoMoneda",label:"Moneda"},
                {key:"importeTotal",label:"Total"},

            ], 
            totalVentas:[],
            footClone:true,
            fixed:true,
            bordered:true,
            cargando:false,
            hora1:0.0,
            minuto1:'',
            hora2:0.0,
            minuto2:'',
            mostrarfiltro:false,
            mensajeAlerta:'',
            dismissSecs: 5,
            dismissCountDown: 0,
            yape:0,
            plin:0,
            trans:0
        }
    },
    mounted() {
        this.InitDate();
        this.documentosTipoPagos();
    },
    methods:{
        InitDate(){
            this.currentdate = this.$moment().format("YYYY-MM-DD  HH:mm:ss");
            this.f1 = this.$moment().format("YYYY-MM-DD 00:00:00");
            this.f2 = this.$moment().format("YYYY-MM-DD 23:59:59");  
        },
       customFormatter: function(date) {
        return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        documentosTipoPagos(){
            let idUser = '';
            if(this.$store.getters.userData.perfil.rolUsuario == 1){
                idUser = '';
            }else if(this.$store.getters.userData.idUsuario){
                idUser = this.$store.getters.userData.idUsuario;
            }
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + "tipopago/reporte",{
                token:this.$store.getters.userToken,
                idUsuario:idUser,
                f1: this.f1,
                f2: this.f2
            })
            .then(response=>(
                this.totales = response.data.totales,
                this.listarDocumentos(response.data.report),
                this.totalVentas = this.totales.pop(),
                this.cargando = false,
                this.hora1 ='',
                this.minuto1 = '', 
                this.hora2 = '',
                this.minuto2 = '' 
            ))
            .catch(error=>(
                console.log(error)
            ))
        },
        listarDocumentos(value){
            if(value.length !=[]){
                let array = []
                let yape = 0
                let plin = 0
                let trans = 0
                this.arrayTipoDocumento = Object.values(value)
                // sumar las formas de pago de Transferencia de fondos
                array.push(value)
                array.forEach(function(element){
                    if(element["Transferencia de fondos"]){
                        element["Transferencia de fondos"].forEach(function(element){
                            if(element.monedero == 1){
                                // console.log(yape += parseFloat(element.importeTotal))
                                yape += parseFloat(element.importeTotal)
                            }
                        })
                        element["Transferencia de fondos"].forEach(function(element){
                            if(element.monedero == 2){
                                // console.log(plin += parseFloat(element.importeTotal)
                                plin += parseFloat(element.importeTotal)
                            }
                        })
                        element["Transferencia de fondos"].forEach(function(element){
                            if(element.monedero == 8){
                                // console.log(trans += parseFloat(element.importeTotal))
                                trans += parseFloat(element.importeTotal)
                            }
                        })
                    }
                })
                this.yape = yape,
                this.plin = plin,
                this.trans = trans
                }
        },
        filtroHora(){
            if(this.mostrarfiltro == false){
                this.mostrarfiltro = true;
            }else if(this.mostrarfiltro == true){
                this.mostrarfiltro = false;
            }  
        },
        validacionHoras(){
            if(this.mostrarfiltro == true){
                if( this.hora1 !='' || this.minuto1 != '' || this.hora2 != '' || this.minuto2 != ''){
                    this.f1 = (this.f1 + " " + this.hora1 + ":" + this.minuto1 + ":" + "59");
                    this.f2 = (this.f2 + " " + this.hora2 + ":" + this.minuto2 + ":" + "59");
                    this.documentosTipoPagos();
                }else{
                    this.f1 = (this.f1 + " " + "00:00:00");
                    this.f2 = (this.f2 + " " + "23:59:59");
                    this.documentosTipoPagos();
                }      
            }else{
                this.f1 = (this.f1 + " " + "00:00:00");
                this.f2 = (this.f2 + " " + "23:59:59");
                this.documentosTipoPagos();
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        exportarCajaBanco(){
            let date1 = this.$moment(this.f1).startOf('day').format('YYYY-MM-DD HH:mm:ss');
            let date2 = this.$moment(this.f2).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            let file = '';
            let tag = document.createElement('i');
            tag.classList.add('fa','fa-spin', 'fa-spinner');
            let name = 'Caja Bancos' + ' ' + date1 + '-' + date2 + '.xlsx';
            this.$swal({
                title: 'Procesando Reporte',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            });
            axios
            .post(process.env.VUE_APP_API_URL + "tipopago/excel",{
                token:this.$store.getters.userToken,
                f1: date1,
                f2: date2,
            })
            .then(response=>{
                console.log('respuesta',response)  
                file = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'+ response.data.base64;
                download(file, name,'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.$swal.close()
            })
            .catch(error=>{
                console.log(error)
            })
        }
    }
}
</script>
<style scoped>
.totalesGeneral{
    float: right;
}
/* .fuente{
    font-family: 'Staatliches', cursive;
} */
table, th, td {
    border: 1px solid black;
}
th,td{
    text-align: center;
}
.tablaTotales{
    width:12%;
    font-size: 15px;
    float: right;
    margin-right: 10px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>